import React from "react";


class KRSubmission extends React.Component{
    render(){
return(
    <div className="KR">
        <h3>-AnXiens- 2025 Open Submission 이벤트가 지금 시작됩니다!</h3>

<p>요구 사항:</p><p>
- 응모 작품에 대한 모든 저작권을 보유하고 있어야 합니다.
</p><p>
- 작품 길이는 1:50~2:20 사이여야 합니다.
</p><p>
- 제출 작품은 마감일 이전에 발표되지 않은 오리지널 곡이어야 합니다.
</p><p>
- 곡에는 적절한 가사가 포함될 수 있습니다. (언어는 무제함) 작품에 가사가 포함되어 있는 경우 작품 제출 시 원본 가사 파일를 제공해 주시기 바랍니다.
</p><p>
- 각 참가자는 최대 3개의 작품을 제출할 수 있으며, 협업 작품에 참여하는 경우 개별 제출 제한에 포함됩니다.
</p><p>
- 참가자는 최소 18세여야 하며 (제출 시 기준), 그렇지 않은 경우 법적 보호자가 서명해야 합니다.
</p><br/><p>

위의 사항을 준수하지 않을 경우 제출한 작품이 실격 처리될 수 있습니다.
</p><br/><p>
제출 후:
</p><p>
- 접수 후 영업일 기준 7일 이내에 확인 이메일을 보내드립니다.
</p><p>
- 제출된 모든 작품은 이벤트에만 사용되며, GLACIA STUDIO에서는 철저하게 보관됩니다.
</p><p>
- 접수된 모든 제출물을 검토한 후 게임 내 사용을 위해 일부를 선택합니다. 선택되는 총 곡 수는 GLACIA STUDIO에서 결정합니다.
</p><p>
- 선정되지 않은 제출곡은 게시하거나 사용하지 않습니다.
</p><p>
- 심사 마감일 이전에 당첨자에게 연락을 드릴 예정이며, 마감일 이전에 제출하신 작품은 자동으로 실격 처리됩니다.
</p><p>
- 검토 종료 후 연락이 없을 경우, 제출하신 작품을 제약 없이 게재하실 수 있습니다.
</p><br/>

<p>
저작권 및 계약 정보:
</p><p>
- 당사가 귀하에게 연락하여 저작권 구매 계약을 체결할 때까지 귀하는 제출된 작품의 저작권을 계속 보유합니다.
</p><p>
- 귀하의 작품이 선정된 후 당사는 귀하와 계약을 체결하며, 해당 곡의 소유권에 대한 라이센스 비용을 지불합니다.
</p><p>
- 귀하께서 제공하신 모든 개인정보는 철저히 비밀로 유지되며, 계약 및 검토용으로만 사용됩니다.
</p><br/><p>

제출 마감일: 2025년 7월 1일
검토 마감일: 2025년 7월 30일
</p><br/><p>
다음 형식에 따라 정보를 제공해 주십시오:
</p><p>
1.귀하의 법적 이름
</p><p>
2. 귀하의 연락처(이메일)
</p><p>
3. 아티스트 이름(게임 내에서 표시되는 이름, 팀으로 제출하는 경우 여기에 모든 멤버를 나열하세요.)
</p><p>
4. 곡 제목</p><p>
5. 템포, 작업에 템포 변경이 포함된 경우 상세(밀리초 또는 미터 단위로 표시)도 제공해 주시기 바랍니다.
</p><p>
6. 작품에대한 간략한 설명과 가사 (가능한 경우)
</p><p>
7. 오디오 파일(48kHz, 24bit), 이름 형식은 2025AXSubmission_[작품 제목].wav 이어야 합니다.
</p><br/><p>

본 이벤트에 대한 최종 해석 권한은 GLACIA STUDIO에 있습니다.
질문이 있으시면 다음 이메일로 문의해 주세요: <a href="https://www.anxiens.com/event/songsubmission2025/">glacia_studio@foxmail.com</a>
</p><br/><br/>
    </div>
    )
}
}

export default KRSubmission